import { hpsAccionesRoles } from '../../acciones-roles/departamentos/hps-acciones-roles';
import { SideBarButton } from '../../nav-list/recursive-sidebar/class/sidebar';
import {
  PreConfigButton2,
  PreConfigButton3,
} from '../../nav-list/recursive-sidebar/configuration/preconfig';

export const HPsRoutes: SideBarButton = {
  data: {
    name: 'HPs',
    appendUrl: './hp',
    roles: [...hpsAccionesRoles.sideNavActions.root], // Agregamos root
  },
  options: PreConfigButton2,
  butons: [
    {
      data: {
        name: 'Asignar WO',
        url: '/items',
        exact: true,
        otherUrls: ['/items/:id'],
        queryParams: { department: 'hp' },
        roles: [...hpsAccionesRoles.sharedActions.items],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Registrar Progreso',
        url: '/work-order',
        roles: [...hpsAccionesRoles.sharedActions.workOrder],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Reporte',
        url: '/management',
        roles: [...hpsAccionesRoles.sharedActions.management],
      },
      options: PreConfigButton3,
    },

    {
      data: {
        name: 'Validacion',
        url: '/validation',
        roles: [...hpsAccionesRoles.sharedActions.validation],
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Etiquetas',
        url: '/packing-box',
        roles: hpsAccionesRoles.sharedActions.packingBox,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Reporte Power BI',
        overWriteUrl: './reportsPBI/hps',
        roles: [...hpsAccionesRoles.sideNavActions.reportsPbiHps],
      },
      options: PreConfigButton3,
    },
  ],
};
